/*
Convert Simple Forms to Form processable by FormGenerator
line
line
line
[x]
line
line

Elements in Simple Form:
  [x:name] label         — data checkbox (switch), named cb_name
  [x] label              — data checkbox (switch), auto-numbered cb1, cb2, ...
  [t:name] label         — tristate switch (Ja/Nein, must be answered), named ts_name
  [!] label              — guard checkbox (not stored, enables submit)
  [_:fieldname] label    — text input
  [a:fieldname] label    — text area input
  [o:fieldname] label | A | B | C — radio buttons
  anything else          — markdown paragraph

Reminder: if adding new elements, update the simpleFormExtractor!
*/

/* Suggestions for futher elements:
Text box:
name = ___
Radio buttons:
sex = (x) male () female
Check boxes:
phones = [] Android [x] iPhone [x] Blackberry
Drop down (Select)
city = {BOS, SFO, (NYC)}
Required fields
 zip code* = ___[50]
*/

const CHECKBOX_PATTERN       = /^\[x(?::(\w+))?\]\s*(.+)$/i
const TRISTATE_PATTERN       = /^\[t(?::(\w+))?\]\s*(.+)$/i
const GUARD_CHECKBOX_PATTERN = /^\[!\]\s*(.+)$/
const TEXT_INPUT_PATTERN     = /^\[_:(\w+)\]\s*(.+)$/
const TEXTAREA_INPUT_PATTERN = /^\[a:(\w+)\]\s*(.+)$/
const RADIO_PATTERN          = /^\[o:(\w+)\]\s*(.+)$/

const simpleFormConverter = (simpleForm) => {
  const lines = simpleForm.split(/\r?\n/);

  let form = [];
  let buffer = [];
  let num = 0;
  let cbCount = 0;
  let triCount = 0;
  let guardCount = 0;
  let lastElement = "";

  // add LineBreak command to form, but avoid multiple line breaks
  const pushLB = () => {
    if ( lastElement !== "lb" ) {
      form.push({
        fieldname: `XlineBreak${++num}`,
        value: {}
      });
      lastElement = "lb";
    };
  };

  // add text to form
  const pushBuffer = () => {
    if ( buffer.length>0 ) {
      pushLB();
      form.push({
        fieldname: `Xmarkdown${++num}`,
        value: buffer.join("  \n")
      });
      lastElement = "buf";
    }
    buffer = [];
  };

  lines.forEach( line => {
    let match;

    if ((match = line.match(RADIO_PATTERN))) {
      pushBuffer();
      pushLB();
      const parts = match[2].split('|').map(s => s.trim());
      const label = parts.shift();
      const options = parts.map(opt => ({ label: opt, value: opt }));
      form.push({
        fieldname: `radio_${match[1]}`,
        tag: 'boxes',
        label: label,
        attributes: {
          type: 'radio',
          options: options
        },
      });
      lastElement = "radio";

    } else if ((match = line.match(TEXT_INPUT_PATTERN))) {
      pushBuffer();
      pushLB();
      form.push({
        fieldname: `txt_${match[1]}`,
        tag: 'input',
        label: match[2].trim(),
        attributes: {
          type: 'text',
          placeholder: match[2].trim()
        },
      });
      lastElement = "txt";

    } else if ((match = line.match(TEXTAREA_INPUT_PATTERN))) {
      pushBuffer();
      pushLB();
      form.push({
        fieldname: `txt_${match[1]}`,
        tag: 'textarea',
        label: match[2].trim(),
        attributes: {
          type: 'text',
          placeholder: match[2].trim(),
          cols: 60
        },
      });
      lastElement = "txt";

    } else if ((match = line.match(TRISTATE_PATTERN))) {
      pushBuffer();
      pushLB();
      const tsFieldname = match[1] ? `ts_${match[1]}` : `ts${++triCount}`;
      form.push({
        fieldname: tsFieldname,
        tag: 'tristate',
        label: match[2].trim(),
        value: 'center',
        validation: { notCenter: true },
      });
      lastElement = "ts";

    } else if ((match = line.match(GUARD_CHECKBOX_PATTERN))) {
      pushBuffer();
      pushLB();
      form.push({
        fieldname: `guard${++guardCount}`,
        tag: 'boxes',
        label: '',
        classname: 'JaNein',
        isGuard: true,
        attributes: {
          type: 'switch',
          options: [{
            label: match[1].trim(),
            value: 'yes'
          }]
        },
      });
      lastElement = "guard";

    } else if ((match = line.match(CHECKBOX_PATTERN))) {
      pushBuffer();
      pushLB();
      const cbFieldname = match[1] ? `cb_${match[1]}` : `cb${++cbCount}`;
      form.push({
        fieldname: cbFieldname,
        tag: 'boxes',
        label: '',
        classname: 'JaNein',
        attributes: {
          type: 'switch',
          options: [{
            label: match[2].trim(),
            value: 'yes'
          }]
        },
      });
      lastElement = "cb";

    } else {
      buffer.push( line );
    }
  }); // lines.forEach

  pushBuffer();

  return form;
} // simpleFormConverter

export default simpleFormConverter;
